var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({'height': _vm.iframeHeight}),domProps:{"innerHTML":_vm._s(_vm.meta.source_code)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }